function validateAge(date) {
  const dateOfBirth = new Date(
    parseInt(date.year, 10),
    parseInt(date.month, 10) - 1,
    parseInt(date.day, 10),
  );

  // from https://www.javatpoint.com/calculate-age-using-javascript
  const month_diff = Date.now() - dateOfBirth.getTime();
  const age_dt = new Date(month_diff);
  const year = age_dt.getUTCFullYear();
  const age = Math.abs(year - 1970);

  return age;
}

function formatDate({ day, month, year }) {
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}

function validateDate(date) {
  const { day, month, year } = date;

  if (!day || !month || !year) {
    return { validDate: false, error: '' };
  }

  const onlyNumericalValues = Object.values(date).every((value) =>
    /^[0-9]+$/.test(value),
  );

  if (
    !onlyNumericalValues ||
    parseInt(day, 10) > 31 ||
    parseInt(month, 10) > 12
  ) {
    return { error: 'Please enter a valid date' };
  }

  if (year.length !== 4) {
    return { error: 'Please use year format YYYY' };
  }

  return { validDate: true, error: '' };
}

function validateAgeAndDate(date) {
  const { error, validDate } = validateDate(date);

  if (error || !validDate) {
    return { error, validDate };
  }

  const age = validateAge(date);

  if (age < 18) {
    return { error: 'You must be 18 or over to use SpareRoom' };
  }

  if (age > 99) {
    return { error: 'Please enter a valid date of birth' };
  }

  const today = new Date();
  const year = today.getFullYear();

  if (parseInt(date.year, 10) >= year) {
    return { error: 'Please enter a valid date of birth' };
  }

  return { validDate: true, error: '' };
}

function splitDateString(date) {
  const splitString = date.split('-');
  return {
    day: splitString[2],
    month: splitString[1],
    year: splitString[0],
  };
}

function getTodaysDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, '0');
  const day = today
    .getDate()
    .toString()
    .padStart(2, '0');

  return `${year}-${month}-${day}`;
}

function dateIsInPast(date) {
  const [year, month, day] = date.split('-');
  const today = new Date();

  const dateInput = new Date(
    parseInt(year, 10),
    parseInt(month, 10) - 1,
    parseInt(day, 10),
  );

  return dateInput.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0);
}

export {
  validateAge,
  validateDate,
  formatDate,
  validateAgeAndDate,
  splitDateString,
  getTodaysDate,
  dateIsInPast,
};
